// اضافه کردن کتابخانه ها به صفحه
import * as React from "react";
import {Link, useLocation, useSearchParams} from "react-router-dom";
import {Instagram, Telegram, Twitter} from '@mui/icons-material';
import Divider from '@mui/material/Divider';
import {ThemeContext} from "../App";
import {useTranslation} from "react-i18next";
import {handleSetQuery} from "../assets/js/main";


export default function Footer(props) {
  // گرفتن متغیر گلوبال از طریق useContext
  // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
  const {t} = useTranslation()
  const location = useLocation();

  return (
     <>
       {/*تغییر تصویر بک گراند در دارک مود*/}
       <div className="footerComponent">
         <div className="container">
           <div className="row">
             <div className="col-6 col-md-6 col-lg-3">
               <img src={process.env.REACT_APP_SITE === 'amnito' ? '/amnito.png' : '/Logo.png'} alt="postex"/>
               <h5>{t("footer.t23")}</h5>
               <div className="action">
                 <a href="https://play.google.com/store/apps/details?id=com.apppost.codein" target="_blank" id="googlePlay"
                 >
                   <button type="button" className="btn-1">
                     <span>{t("homeDesktop.s4.t5")}</span>
                     <svg width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <path
                          d="M13.222 15.0031L0.82125 28.4444L0.443789 28.8576C0.209121 28.5108 0.0509766 28.0976 0.015293 27.6385C0.00509766 27.557 0 27.4752 0 27.3937V2.60739C0 2.05146 0.16834 1.55153 0.443789 1.14331L13.222 15.0031Z"
                          fill="#59A6CA"/>
                       <path d="M18.7971 8.95313L13.2216 15.0031L0.443359 1.14329C1.1677 0.0823325 2.64701 -0.371593 3.90191 0.352743L18.7971 8.95313Z" fill="#B6D9A2"/>
                       <path
                          d="M26.6631 15.0744C26.6427 15.9213 26.2091 16.768 25.3674 17.2526L18.7972 21.0478L13.2217 15.003L18.7972 8.95312L22.9291 11.3405L25.3674 12.7483C26.2601 13.2636 26.6937 14.1715 26.6631 15.0744Z"
                          fill="#F0CE89"/>
                       <path d="M0.444336 28.857C1.16902 29.9185 2.6474 30.371 3.89996 29.6478L18.795 21.0481L13.2194 15.0007L0.444336 28.857Z" fill="#B6547C"/>
                       <path opacity="0.2"
                             d="M26.6055 14.4403C26.4618 13.7654 26.0498 13.1421 25.3678 12.7483L22.9294 11.3405L18.7975 8.95313L3.90234 0.352743C2.64744 -0.371593 1.16813 0.0823325 0.443789 1.14329C0.16834 1.55151 0 2.05143 0 2.60737V16.8878C2.14928 17.0703 4.34918 17.1659 6.58893 17.1659C9.40049 17.1659 12.1465 17.011 14.8107 16.7262L13.2271 15.0086L14.8113 16.7262C18.9837 16.2802 22.9434 15.501 26.6055 14.4403Z"
                             fill="white"/>
                     </svg>
                   </button>
                 </a>
                 <a href="http://cafebazaar.ir/app/?id=com.apppost.codein&ref=share" target="_blank" id="cafeBazaar">
                   <button type="button" className="btn-2">
                     <span>{t("homeDesktop.s4.t6")}</span>
                     <img src={require('../assets/img/bazzar.png')} alt="bazzar"/>
                   </button>
                 </a>
               </div>
             </div>
             <div className="col-6 col-md-6 col-lg-3">
               <h5>{t("footer.t1")}</h5>
               <Link to={{pathname: '/rules', search: location?.search}} id="rulesFooter">{t("footer.t2")}</Link>
               <Link to={{pathname: '/aboutus', search: location?.search}} id="aboutusFooter">{t("footer.t3")}</Link>
               <a href="https://mag.postex.ir/category/news/" target="_blank" id="newsFooter">{t("footer.t4")}</a>
               <a href="https://mag.postex.ir/" target="_blank" id="postexFooter">{t("footer.t5")}</a>
               <a href="https://mag.postex.ir/category/mags/" target="_blank" id="magsFooter">{t("footer.t6")}</a>
             </div>
             <div className="col-6 col-md-6 col-lg-3">
               <h5>{t("footer.t7")}</h5>
               <a href="https://postex.ir/api/postexApi.zip" target="_blank" id="postexApiFooter">{t("footer.t8")}</a>
               {process.env.REACT_APP_SITE === 'postex' && <a href="https://app.didar.me/customer/form/4c5aad76-8be1-4cf1-9b92-90925518ae2c" target="_blank" id="didarFooter">{t("footer.t9")}</a>}

               {/*<Link to={{pathname: '/loginedu', search: location?.search}} id="logineduFooter">{t("footer.t10")}</Link>*/}
               <Link to={{pathname: '/representation', search: location?.search}} id="representationFooter">{t("footer.t11")}</Link>
               <Link to={{pathname: '/cartoon', search: location?.search}} id="cartoonFooter">{t("footer.t12")}</Link>
               <a href="https://postex.ir/TopicCollection" target="_blank" id="TopicCollectionFooter">{t("footer.t13")}</a>
               <Link to={{pathname: '/faq', search: location?.search}} id="faqFooter">{t("footer.t14")}</Link>
             </div>
             <div className="col-6 col-md-6 col-lg-3">
               <h5>{t("footer.t15")}</h5>
               <Link to={{pathname: '/dashboard', search: location?.search}} id="dashboardFooter">{t("footer.t16")}</Link>
               <Link to={{pathname: '/orderList', search: location?.search}} id="orderListFooter">{t("footer.t17")}</Link>
               <Link to={{pathname: '/settingAccount', search: location?.search}} id="settingAccountFooter">{t("footer.t18")}</Link>
               <button onClick={() => props.handleClick()} id="handleScrollIntoView">{t("footer.t19")}</button>
               {/*<a href="/">{t("footer.t20")}</a>*/}
               <Link to={{pathname: '/support/list', search: location?.search}} id="supportListFooter">{t("footer.t21")}</Link>
             </div>

             <Divider/>

             <div className="copyRight">
               <h6>{t("footer.t26")}</h6>
               <div className="social">
                 <a href="https://www.instagram.com/postex.ir" className="item" id="instagramFooter"><Instagram/></a>
                 <a href="https://t.me/postex" className="item" id="telegramFooter"><Telegram/></a>
                 <a href="https://twitter.com/postex_ir" className="item" id="twitterFooter"><Twitter/></a>
               </div>
             </div>

           </div>
         </div>
       </div>
     </>
  )
}
